<script>
import CampaignApi from "@/services/campaign-api";
import MenuApi from "@/services/menu-api";
import SettingsOrderMenu from "@/components/SettingsOrderMenu";
import PrivilegeTable from "@/router/views/privilege-table/privilege-table";

import { mapGetters } from 'vuex';


export default {
  components: {
    SettingsOrderMenu,
    PrivilegeTable,
  },

  data() {
    return {
      campaign: null,
      menu: {},
      key: 0
    };
  },

  mounted() {
    this.findDetailsCampainById();
    this.$nextTick(() => {
      const mainContent = document.querySelector(".main-content");
      if (mainContent) {
        mainContent.style.overflow = "visible";
      }
    });
  },

  computed:{
        ...mapGetters('menu', ['menuCampaignId']),
  },

  watch: {
    menuCampaignId() {
      if (this.menuCampaignId) {
        this.findDetailsCampainById();
      }
    },
  },

  methods: {
    initcampaign() {
      if (this.campaign?.menuCode) {
        this.getMenuByCode(this.campaign.menuCode);
      }
    },

    findDetailsCampainById() {
      if (!this.menuCampaignId) return;

      CampaignApi.findDetailsCampainById(this.menuCampaignId).then(
        (result) => {
          if (result) {
            this.campaign = result;
            this.key++
            this.initcampaign();
          }
        }
      );
    },

    getMenuByCode(menuCode) {
      MenuApi.getMenuByCode(menuCode).then((result) => {
        if (result) {
          this.menu = result;
        }
      });
    },
  },
};
</script>


<template>
  <div v-if="campaign && menu">
    
    <SettingsOrderMenu :campaign="campaign" :menu="menu" :key="key"  />

    <div class="mt-md-4 mt-2">
        <PrivilegeTable :campaign="campaign" :key="key" />
    </div>


  </div>
</template>
